import React, { memo, useCallback } from 'react';

import styles from './styles.module.scss';
import MaterialEntry from '../../MaterialEntry';

interface MaterialModel {
	displayName: string;
	description: Nullable<string>;
	materialGroups: string[];
	vendor: Nullable<string>;
	vendorUniqueId: Nullable<string>;
}

interface OwnProps<M extends MaterialModel> {
	material: M;
	className?: string;
	onDelete: (material: M) => void;
}

interface OwnPropsAdded {
	added: true;
	removed?: never;
}

interface OwnPropsRemoved {
	added?: never;
	removed: true;
}

type Props<M extends MaterialModel> = OwnProps<M> & (OwnPropsAdded | OwnPropsRemoved);

const MaterialEntryChange = <M extends MaterialModel>(props: Props<M>) => {
	const { material, added, removed, className = '', onDelete } = props;

	const handleDelete = useCallback(() => {
		onDelete(material);
	}, [material, onDelete]);

	const resolvedClassName = `
		${styles.MaterialEntryChange} 
		${added ? styles.added : ''} 
		${removed ? styles.removed : ''}
		${className}
	`;

	const icon = added ? 'icon-plus' : 'icon-minus';

	return (
		<div className={resolvedClassName}>
			<span className={`${styles.changeIcon} ${icon}`} />
			<MaterialEntry className={styles.materialEntry} material={material} />
			<span className={`${styles.removeIcon} icon-delete`} onClick={handleDelete} />
		</div>
	);
};

export default memo(MaterialEntryChange);
